/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './product-attribute.reducer';

export const ProductAttributeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const productAttributeEntity = useAppSelector(state => state.productAttribute.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="productAttributeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.productAttribute.detail.title">ProductAttribute</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.productAttribute.id">Id</Translate>
            </span>
          </dt>
          <dd>{productAttributeEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.productAttribute.active">Active</Translate>
            </span>
          </dt>
          <dd>{productAttributeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.productAttribute.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{productAttributeEntity.lastUpdated}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.productAttribute.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{productAttributeEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.productAttribute.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{productAttributeEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.productAttribute.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{productAttributeEntity.cursor}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.productAttribute.value">Value</Translate>
            </span>
          </dt>
          <dd>{productAttributeEntity.value}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.productAttribute.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{productAttributeEntity.comments}</dd>
          <dt>
            <span id="productId">
              <Translate contentKey="tinyMedicRestApp.productAttribute.productId">Product Id</Translate>
            </span>
          </dt>
          <dd>{productAttributeEntity.productId}</dd>
          <dt>
            <span id="productType">
              <Translate contentKey="tinyMedicRestApp.productAttribute.productType">Product Type</Translate>
            </span>
          </dt>
          <dd>{productAttributeEntity.productType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.productAttribute.type">Type</Translate>
          </dt>
          <dd>{productAttributeEntity.type ? productAttributeEntity.type.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.productAttribute.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{productAttributeEntity.pharmacy ? productAttributeEntity.pharmacy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/product-attribute" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/product-attribute/${productAttributeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProductAttributeDetail;
